<template>
<div class="calculation_stage_wrap" id="calculation_stage_wrap">
<div class="calculation_stage" id="calculation_stage" :style="stagezoom">
	
<CalculationNode  v-for="node in nodes" :node="node" ></CalculationNode>
<CalculationConnection  v-for="connection in connections" :connection="connection" ></CalculationConnection>


</div>
</div>
</template>

<script>
import CalculationNode from "./CalculationNode"
import CalculationConnection from "./CalculationConnection"

export default {
  props:["nodes","connections"],
  components:{CalculationNode,CalculationConnection},
  name: 'CalculationStage',

  data () {
    return {
    	currentX:0,
    	currentY:0,
    	initialX:0,
    	initialY:0,
    	xOffset:0,
    	yOffset:0,
    	active:false,
    	dragItem:null,
    }
  },
  computed:{
  	stagezoom()
  	{
  		console.log(this.$store.state.calculations.stagezoom)
  		return "transform: scale("+this.$store.state.calculations.stagezoom+");width:"+(this.$store.state.calculations.stagezoom+1)*2000+"px;height:"+(this.$store.state.calculations.stagezoom+1)*1000+"px"
  		
  	}
  },
  mounted()
  {
  	
  },
  methods:{
  }
}
</script>

<style lang="css" scoped>
</style>